module.exports = "/images/city3.jpg?ce19ba6626e726fff487f14bbd36bee9";